import React from 'react';
import styleService from '@nykaa/deals-utils/styles';
import styled from '../../../theme';
const { getPaddingStyles, getMarginStyles, getFontStyles, setVisibility, } = styleService.utils;
export const ProductUnitStyled = styled.div `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  min-height: 14px;
  text-overflow: ellipsis;
  max-width: -webkit-fill-available;
  clear: both;
  display: list-item;
  overflow: hidden;
  white-space: nowrap;
  ${({ visible, visibility }) => visibility && setVisibility(visible)};
`;
const ProductUnit = ({ style, productOptions, visibility }) => React.createElement(ProductUnitStyled, Object.assign({}, style, { visibility: visibility }), productOptions);
export default ProductUnit;
